import { Inject } from '@angular/core';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  ChangeDetectorRef,
  effect,
  NgZone,
} from '@angular/core';
import { SESSION_DATA_SOURCE, SessionDataSource } from '../../../core/services/session-data-source';
import {
  PatientTargetDataModel,
  PatientTargetModel,
  PatientTargetStatus,
} from '../../../core/api/models';
import { BaseBoxComponent } from '../base-box/base-box.component';
@Component({
  selector: 'app-box-frequency',
  templateUrl: './box-frequency.component.html',
  styleUrls: ['./box-frequency.component.css', '../data-entry-feedback.css'],
  standalone: false,
})
export class BoxFrequencyComponent extends BaseBoxComponent {
  text: string | null | undefined = '-';
  sessionValue: number = 0;
  @Input() dayValue: number = 0;
  @Input() showDayValue: boolean = false;
  @Input() isTopBox: boolean = true;
  @Input() isBottomBox: boolean = false;
  @Input() isPreview?: boolean;
  targetID: number = 0;

  @Input() target?: PatientTargetModel;

  targetData: PatientTargetDataModel[] = [];
  isEditing: boolean = false;

  @ViewChild('inputField') inputField!: ElementRef;
  remainingTrials: number = 0;
  addingTargetData: boolean = false;
  /** Brief success state for visual feedback when a tap is recorded (cleared after 200ms). */
  justRecorded: boolean = false;

  constructor(
    protected override cdRef: ChangeDetectorRef,
    @Inject(SESSION_DATA_SOURCE) private patientSessionService: SessionDataSource,
    private ngZone: NgZone
  ) {
    super(cdRef);
    effect(() => {
      this.patientSessionService.dataChanged();
      const targetData = this.patientSessionService.getTargetData(
        this.targetID
      );
      if (targetData) {
        this.targetData = targetData.filter((t) => !t.DeletedDate);

        //get targetData with   unique recordedDate
        this.targetData = this.targetData.filter(
          (value, index, self) =>
            index ===
            self.findIndex((t) => t.RecordedDate === value.RecordedDate)
        );

        this.remainingTrials =
          (this.target?.DesiredTrials ?? 0) - this.targetData.length;
        if (this.remainingTrials < 0) {
          this.remainingTrials = 0;
        }

        if (
          this.target?.TargetStatus === PatientTargetStatus.Mastered ||
          this.target?.TargetStatus === PatientTargetStatus.Closed ||
          this.target?.TargetStatus === PatientTargetStatus.Fluent
        ) {
          this.remainingTrials = 0;
        }
        //count the number of targetData that have the same RecordedDate
        const count = this.targetData.length;
        this.sessionValue = count;
      } else {
        this.sessionValue = 0;
        this.targetData = [];
      }
      this.cdRef.markForCheck();
      this.cdRef.detectChanges();
      (this.mainBox?.nativeElement as HTMLElement)?.getBoundingClientRect(); // forces reflow
      setTimeout(() => {
        this.cdRef.markForCheck();
        this.cdRef.detectChanges();
        (this.mainBox?.nativeElement as HTMLElement)?.getBoundingClientRect(); // forces reflow
      }, 100);
    });
  }

  ngOnInit(): void {
    this.text = this.target?.TargetName ?? '-';
    this.targetID = this.target?.ID ?? 0;
  }

  override onClickOutside() {
    this.isEditing = false;
    super.onClickOutside();
  }

  toggleEdit(): void {
    this.isEditing = !this.isEditing;
  }

  increaseSessionValue(): void {
    this.ngZone.run(() => this.addSessionValue());
  }

  addSessionValue(): void {
    if (this.addingTargetData) {
      return;
    }
    this.addingTargetData = true;
    //get date with up to seconds, remove milisencods
    const recordedDate = new Date()
      .toISOString()
      .slice(0, 19)
      .replace('T', ' ');
    const dateToSave = new Date(recordedDate).fromUTCtoServerString();

    //check if the dateToSave is already in the targetData
    const isDateInTargetData = this.targetData.some(
      (t) => t.RecordedDate === dateToSave
    );
    if (isDateInTargetData) {
      this.addingTargetData = false;
      return;
    }

    const targetData: PatientTargetDataModel = {
      IntValue: 1,
      PatientSessionID: 0,
      PatientTargetID: this.targetID,
      RecordedDate: dateToSave,
      TextValue: '1',
    };
    this.patientSessionService.addTargetData(targetData);
    this.justRecorded = true;
    setTimeout(() => {
      this.justRecorded = false;
    }, 220);
    setTimeout(() => {
      this.addingTargetData = false;
    }, 1000);
  }

  clickedBox(): void {
    if (!this.isEditing) {
      this.increaseSessionValue();
    }
  }

  decreaseSessionValue(): void {
    if (this.sessionValue > 0) {
      this.deleteData();
    }
  }

  override doLongPress(): void {
    this.toggleEdit();
    if (this.inputField && this.inputField.nativeElement) {
      this.inputField.nativeElement.focus();
    }
  }

  deleteData(): void {
    //get the last targetData
    const lastTargetData = this.targetData.filter((t) => !t.DeletedDate)[
      this.targetData.length - 1
    ];
    lastTargetData.DeletedDate = new Date().toServerString();
    this.patientSessionService.saveTargetData(lastTargetData);
  }
}
